<template>
<b-container fluid class="container">
  <b-row>
        <b-col class="text-left" style="background-color: #DD3E23;">
          <b-button @click.prevent="regresar()" style="color: white" variant="link">REGRESAR</b-button>
        </b-col>
 </b-row>

    <b-row class="justify-content-md-center">
        <h1 class="mt-5">RECUPERA TU CONTRASEÑA</h1>
        <p class="mt-2">Ingresa tu usuario y/o cuenta de correo.</p>
        <b-col  col md="4" class="card-body text-center">
          <b-form-group id="input-group-5" label-for="input-5" class="text-center">
              <h6>Usuario / Correo electrónico</h6>
              <b-form-input id="input-5"  type="email" placeholder="Ingresa tu email" required ></b-form-input>
          </b-form-group>
          <b-col>
            <b-button @click.prevent="recover()" variant="primary" class="button_H">SOLICITAR NUEVA CONTRASEÑA</b-button>
          </b-col>
        </b-col>
      </b-row>
</b-container>
</template>

<script>
export default {
  name: 'Recover',

    data() {
    return {
      regresar(){
        this.$router.push({ path: '/Bienvenida'});
      }

      };
  },

  methods: {


  },
  
  created() {

  }
}
</script>

<style scoped>


</style>